import { FC, useEffect, useState } from 'react';
import { Box, Paper, Tab, useTheme } from '@mui/material';
import DashboardPageLayout from 'src/frontend-common/components/DashboardPageLayout';
import DateFilter from 'src/components/DateFilter';
import QueryValuesLayout from 'src/components/Layouts/QueryValuesLayout';
import { CustomTabs } from 'src/frontend-common/style/common';
import Row from 'src/frontend-common/components/Row';
import AnalyticsPhone from 'src/pages/Analytics/components/AnalyticsPhone';
import AnalyticsEmail from 'src/pages/Analytics/components/AnalyticsEmail';
import AnalyticsIP from 'src/pages/Analytics/components/AnalyticsIp';
import AnalyticsDomain from 'src/pages/Analytics/components/AnalyticsDomain';
import AnalyticsDigitalScore from 'src/pages/Analytics/components/AnalyticsDigitalScore';
import AnalyticsLogin from 'src/pages/Analytics/components/AnalyticsLogin';
import { useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { selectUser } from 'src/redux/slices/userSlice';
import { isAdmin } from 'src/utils/user';
import AnalyticsBotDetection from 'src/pages/Analytics/components/AnalyticsBotDetection';
import { NavigateCallbackFn } from 'src/frontend-common/dto/Interfaces/FrontendLookups';

const Analytics: FC<{ navigateTo: NavigateCallbackFn }> = ({ navigateTo }) => {
  const [activeTab, setActiveTab] = useState<number | undefined>(0);

  const params = useLocation();

  const user = useSelector(selectUser);
  const isUserAdmin = isAdmin(user);

  useEffect(() => {
    const tabFromSearchString = new URLSearchParams(params.search).get('tab');
    if (tabFromSearchString) {
      if (
        isNaN(Number(tabFromSearchString)) ||
        Number(tabFromSearchString) < 0 ||
        Number(tabFromSearchString) > listOfAnalyticsTabs.length - 1 ||
        (!isUserAdmin && listOfAnalyticsTabsAdminOnly.includes(listOfAnalyticsTabs[Number(tabFromSearchString)] || ''))
      ) {
        setActiveTab(0);
        return;
      }
      setActiveTab(Number(tabFromSearchString));
    }
  }, [params]);

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const handleTabChange = (newValue: number) => {
    setActiveTab(newValue);
  };

  const theme = useTheme();
  const listOfAnalyticsTabs = ['Onboarding', 'Phone Number', 'Email Address', 'IP Address', 'Domain', 'Login', 'Session'];
  const listOfAnalyticsTabsAdminOnly = ['Session'];

  return (
    <QueryValuesLayout excludeValues={['token']}>
      {({ dateRange, setDateRange, setTab }) => (
        <DashboardPageLayout
          title="Analytics"
          aside={
            <Row>
              <DateFilter
                dateRange={dateRange}
                setDateRange={(range) => {
                  setDateRange(range);
                }}
              />
            </Row>
          }
        >
          <Box style={{ marginBottom: 12 }}>
            <Paper style={{ padding: theme.spacing(0, 2) }}>
              <CustomTabs
                value={activeTab}
                indicatorColor="primary"
                onChange={(_event: unknown, newValue: number) => {
                  handleTabChange(newValue);
                  setTab(newValue);
                }}
              >
                {listOfAnalyticsTabs
                  .filter((tabName) => (isUserAdmin ? true : !listOfAnalyticsTabsAdminOnly.includes(tabName)))
                  .map((tab) => (
                    <Tab label={tab} key={tab} />
                  ))}
              </CustomTabs>
            </Paper>
          </Box>
          <>
            {activeTab === 0 && <AnalyticsDigitalScore dateRange={dateRange} navigateTo={navigateTo} />}
            {activeTab === 1 && <AnalyticsPhone dateRange={dateRange} navigateTo={navigateTo} />}
            {activeTab === 2 && <AnalyticsEmail dateRange={dateRange} navigateTo={navigateTo} />}
            {activeTab === 3 && <AnalyticsIP dateRange={dateRange} navigateTo={navigateTo} />}
            {activeTab === 4 && <AnalyticsDomain dateRange={dateRange} navigateTo={navigateTo} />}
            {activeTab === 5 && <AnalyticsLogin dateRange={dateRange} navigateTo={navigateTo} />}
            {activeTab === 6 && isUserAdmin && <AnalyticsBotDetection dateRange={dateRange} navigateTo={navigateTo} />}
          </>
        </DashboardPageLayout>
      )}
    </QueryValuesLayout>
  );
};

export default Analytics;
